export default __webpack_public_path__ + "static/media/7.88ebf50b.svg";